import type { ComposerTranslation } from "vue-i18n";
import {
  computeTooltipDurationValue,
  getUnit,
  Unit,
  type RoundMode,
} from "~/modules/dtwin/utils/dtwinsListConnectivityStatus";

/**
 * Function used to extract the tooltip to be displayed in the tooltip.
 * @param durationInSeconds Duration in seconds to be analyzed.
 * @param mode Duration computation mode. It is used to the right rounded duration representation.
 */
export function getDuration(
  durationInSeconds: number,
  mode: RoundMode,
  t: ComposerTranslation,
): string | null {
  if (durationInSeconds != null && durationInSeconds !== 0) {
    const unit = getUnit(durationInSeconds);
    if (unit === Unit.SECONDS) {
      return `${t("dtwins.list.attributes.connectivity.duration.seconds", { count: durationInSeconds })}`;
    } else if (unit === Unit.MINUTES) {
      return `${t("dtwins.list.attributes.connectivity.duration.minutes", { count: computeTooltipDurationValue(durationInSeconds, Unit.MINUTES, mode) })}`;
    } else {
      return `${t("dtwins.list.attributes.connectivity.duration.hours", { count: computeTooltipDurationValue(durationInSeconds, Unit.HOURS, mode) })}`;
    }
  }
  return null;
}
